"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ContactPentair;
var _react = _interopRequireWildcard(require("react"));
var _ContactPentairComponent = _interopRequireDefault(require("../components/ContactPentairComponent"));
var _images = _interopRequireDefault(require("../common_features/assets/images"));
var _Services = require("../common_features/utility/Services");
var _reactRouterDom = require("react-router-dom");
var _RoutePath = _interopRequireDefault(require("../RoutePath"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ContactPentair(props) {
  const [isModalLoading, setIsModalLoading] = (0, _react.useState)(false);
  const [supportMessage, setSupportMessage] = (0, _react.useState)("");
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [selectedCategory, setSelectedCategory] = (0, _react.useState)("General Support");
  const [selectedCategoryDesktop, setSelectedCategoryDesktop] = (0, _react.useState)({
    "title": "General Support",
    "index": 0
  });
  const [categoryValue, setCategoryValue] = (0, _react.useState)(1);
  const [displayPasswordChangeModal, setDisplayPasswordChangeModal] = (0, _react.useState)(false);
  const [openErrorModal, setopenErrorModal] = (0, _react.useState)(false);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const dropdownList = [{
    "title": "General Support",
    "index": 1
  }, {
    "title": "Device Support",
    "index": 2
  }, {
    "title": "Report Bugs",
    "index": 3
  }];
  const successData = {
    variant: "password-change-modal",
    displayModal: displayPasswordChangeModal,
    modalHeaderIcon: true,
    displayCrossIcon: false,
    modalHeaderText: "Message Sent",
    modalHeaderTextStyle: {
      color: "#4F8309"
    },
    modalDetailText: "Thanks for your message. We'll respond to you within 48 hours.",
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: "Done",
    negativeActionButtonTitle: null,
    positiveAction: () => handleSucessModal()
  };
  const failureData = {
    variant: "warning-modal",
    displayModal: openErrorModal,
    modalHeaderIcon: true,
    displayCrossIcon: false,
    modalHeaderText: "Something went wrong",
    modalHeaderTextStyle: {
      color: "#E00932"
    },
    modalDetailText: "There was an error sending your message.  Please try again.",
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px"
    },
    positiveActionButtonTitle: "Continue",
    positiveAction: () => handleRetryCancel()
  };
  const handleSucessModal = () => {
    setDisplayPasswordChangeModal(false);
    navigate(_RoutePath.default.admin.useLink);
  };
  const handleRetryCancel = () => {
    setopenErrorModal(false);
  };
  const onModalClick = () => {
    setIsModalLoading(true);
  };
  const contact_pentair = ["General Support", "Device Support", "Report Bugs"];
  const onClickSupport = (item, a) => {
    setCategoryValue(a);
    setSelectedCategory(item);
    setIsModalLoading(false);
  };
  const selectedCategoryDesktopView = item => {
    setCategoryValue(item.index);
    setSelectedCategoryDesktop(item);
    setIsModalLoading(false);
  };
  const onChangeSupportMessage = e => {
    setSupportMessage(e.target.value);
  };
  const onClickSend = async () => {
    setIsLoading(true);
    await (0, _Services.contactPentair)(categoryValue, supportMessage).then(apiResp => {
      if (apiResp && apiResp.success) {
        setIsLoading(false);
        setDisplayPasswordChangeModal(true);
      } else {
        setIsLoading(false);
        setopenErrorModal(true);
      }
    }).catch(error => {
      console.log(error);
      setIsLoading(false);
      setopenErrorModal(true);
    });
  };
  function checkSendDisabled() {
    return selectedCategory && supportMessage || selectedCategoryDesktop && supportMessage || false;
  }
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ContactPentairComponent.default, {
    wrapperStyle: {
      flex: 1
    },
    categoryDropDownList: dropdownList,
    isSuccessModal: true,
    modalDetailText: "You have changed your password successfully!",
    continueButtonText: "Done",
    displayPasswordChangeModal: displayPasswordChangeModal,
    isLoading: isLoading,
    selectedCategory: selectedCategory,
    selectedCategoryDesktop: selectedCategoryDesktop,
    selectingCategory: e => {
      selectedCategoryDesktopView(e);
    },
    headerText: "Contact Us",
    headerSubText: "We are always looking to improve! Please select the category you need help with below.",
    firstNameText: "Message",
    contact: contact_pentair,
    BlueTick: _images.default.rightTick.default,
    supportMessage: supportMessage,
    onChangeSupportMessage: e => {
      onChangeSupportMessage(e);
    },
    firstNamePlaceholderText: "Write a Message",
    sendButton: "Send",
    onClickSend: onClickSend,
    onContactPentair: isModalLoading,
    modalClick: onModalClick,
    downwardArrow: _images.default.downwardArrow.default,
    onClickSupport: onClickSupport,
    modalDropdownData: displayPasswordChangeModal ? successData : failureData,
    onClickSendDisabled: checkSendDisabled()
  }));
}